import { render } from "./PrescriptionGenerate.vue?vue&type=template&id=4ae75f08&scoped=true"
import script from "./PrescriptionGenerate.vue?vue&type=script&lang=js"
export * from "./PrescriptionGenerate.vue?vue&type=script&lang=js"

import "./PrescriptionGenerate.vue?vue&type=style&index=0&id=4ae75f08&scoped=true&lang=css"
import "./PrescriptionGenerate.vue?vue&type=style&index=1&id=4ae75f08&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae75f08"]])

export default __exports__